<div class="position-relative" [nbSpinner]="pending">
  <div class="modal-dialog modal-dialog-centered mobilePopup" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <nb-badge *ngIf="currentExercise" [text]="currentExercise" status="info" class="position-relative m-1">
        </nb-badge>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="!Item.isQuickAdd">
          {{ Item.name }}
        </h5>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="Item.isQuickAdd">
          {{ Item.customName }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
          <span aria-hidden="true">×</span>
        </button>
      </div>




      <div class="modal-body scrollbar-hidden overlay-item"
        style="text-align: center; max-width: 100%; overflow: auto; max-height: 80vh;">

        <div class="d-flex align-items-center block-ledgend-normal" style="position: relative;" *ngFor="let item of fitnessBlock.items; let i = index" (click)="item.order !== this.Item.order && onGoToIndex(WorkoutDetailStatus.Skipped, null, i)"[class.block-ledgend-selected]="item.order === this.Item.order">
            <nb-badge *ngIf="currentExercise" text="{{OrderLabel + (item.order + 1)}}" status="info"
              class="position-relative m-1">
            </nb-badge>
            <img style="max-height: 30px; max-width: 50px; object-fit: contain;"
              [src]="!item.useFemaleVersion ? item.imageUrl && item.imageUrl != 'null'? item.imageUrl: item.exerciseVideoThumbnailUrl : item.femaleImageUrl"
            />
            <div style="
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis; text-align: left; margin-left: 3px; flex-grow: 1;">
              {{item.name}}</div>
              <i *ngIf="workout?.patientWorkoutDataDetails" [class]="getExerciseIcon(item)"></i>
              <!-- <nb-badge *ngIf="getSupersetTag(item)" [text]="getSupersetTag(item)" style="top:-10px; right:-10px;"></nb-badge> -->
        </div>




        <mat-tab-group class="fitness-overlay-tab-group"
          style="padding-top: 10px; margin-bottom: 20px;">
          <mat-tab label="Image">
            <img *ngIf="(!Item.isQuickAdd && (Item.imageUrl || Item.femaleImageUrl || (Item.exerciseVideoThumbnailUrl && Item.exerciseVideoThumbnailUrl != 'null'))) else elseVideo" style="
                padding: 10px;
                max-height: 400px;
                max-width: 100%;
                margin: auto;
              " [src]="!Item.useFemaleVersion ? Item.imageUrl && Item.imageUrl != 'null'? Item.imageUrl: Item.exerciseVideoThumbnailUrl : Item.femaleImageUrl" alt="Fitness Image" />
              <ng-template #elseVideo>
                <video style="
                padding: 10px;
                max-height: 400px;
                max-width: 100%;
                margin: auto;
              ">
                  <source [src]="!Item.useFemaleVersion ? getVideoUrl(Item.videoUrl) : getVideoUrl(Item.femaleVideoUrl)" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </ng-template>

            <div *ngIf="Item.isQuickAdd" class="quick-add-custom-name-overlay">
              {{ Item.customName }}
            </div>
          </mat-tab>

          <mat-tab label="Video" *ngIf="Item.videoUrl && Item.videoUrl != 'null'">
            <div style="
                width: 100%;
                max-height: 350px;
                padding: 10px;
                margin: auto;
              ">
              <video controls width="100%" height="100%">
                <source [src]="
                    !Item.useFemaleVersion ? getVideoUrl(Item.videoUrl) : getVideoUrl(Item.femaleVideoUrl)
                  " type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </mat-tab>

          <mat-tab label="Youtube" *ngIf="Item.youtubeUrl && Item.youtubeUrl != 'null'">
            <div style="width: 100%; padding: 10px">
              <iframe [src]="safeYoutubeSrc" frameborder="0" allowfullscreen></iframe>
            </div>
          </mat-tab>
        </mat-tab-group>
        <nb-card *ngIf="Item.instructions != null && Item.instructions != ''">
          <nb-card-header class="instruction-header">
            <div>Instructions</div>
          </nb-card-header>

          <nb-card-body class="instruction-body" style="white-space: pre-wrap">{{ Item.instructions }}</nb-card-body>
        </nb-card>
        <hr />
        <div>
          <div class="one-max-rep-row">
            <span>One Max Rep: </span>
            <pounds-and-kg [(ngModel)]="Item.oneRepMax" [isImperial]="IsPreferredUnitImperial">
            </pounds-and-kg>
          </div>

          <div class="exercise-edit-setting-detail-row">
            <table class="styled-table d-inline-block">
              <thead>
                <th>Set</th>
                <th>{{ RepLabel }}</th>
                <th>Tempo</th>
                <th>Rest</th>
                <th>Weight ({{ IsPreferredUnitImperial ? 'lbs' : 'Kg' }})</th>
                <th>
                  Used Weight ({{ IsPreferredUnitImperial ? 'lbs' : 'Kg' }})
                </th>
                <th>
                  Reps<br/>Done
                </th>
              </thead>

              <tbody>
                <tr *ngFor="let row of settingDetails">
                  <td>
                    {{ row.Set }}
                  </td>


                  <td *ngIf="!IsMaxRep">
                    {{ row.RepsOrTime }}
                  </td>
                  <td *ngIf="IsMaxRep">
                    <!-- <input nbInput style="width: 100%; min-width: 50px" [(ngModel)]="row.RepsOrTime" type="number"
                      min="1" /> -->
                      Max

                  </td>


                  <td>
                    {{ row.Tempo }}
                  </td>
                  <td>
                    {{ row.Rest }}
                  </td>
                  <td>
                    {{ row.displayWeight }}
                  </td>
                  <td>
                    <input nbInput class="number-input" [(ngModel)]="row.UsedWeight" type="number" inputmode="numeric"
                      min="1" *ngIf="Item.weightType == WeightType.Procent1MR"/>
                    <pounds-and-kg [(ngModel)]="row.UsedWeight"
                      [isImperial]="IsPreferredUnitImperial" *ngIf="Item.weightType == WeightType.AbsoluteValue">
                    </pounds-and-kg>
                  </td>
                  <td>
                    <input nbInput class="number-input" inputmode="numeric" [(ngModel)]="row.RepsDone" type="number"
                      min="1" />
                  </td>
                </tr>
              </tbody>
            </table>
            <span class="float-right" style="font-size: 8pt">Last time completed: {{ lastTimeCompleted }}.</span><br />
          </div>
          <div class="d-flex mt-4 justify-content-end">
            <button nbButton status="warning" class="px-1 mx-1 btn-circle btn-xl"
              (click)="onNext(WorkoutDetailStatus.Skipped)" *ngIf="isWorkout">
              Skip & Move to Next
            </button>

            <button nbButton class="px-1 btn-circle btn-xl btn-main" [disabled]="(!workout && isWorkout)" (click)="saveExerciseLog()">
              Mark As Completed
            </button>
          </div>
          <div class="clearfix"></div>

          <div class="exercise-progress-graph">
            <fieldset>
              <legend style="text-align: left">Progression</legend>
              <div class="chartWrapper">
                <div class="chartAreaWrapper">
                  <chart #chart type="line" [data]="graphData" [options]="graphOptions"></chart>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <br />
        <br />
      </div>
    </div>
  </div>
  <app-fitness-workout-overlay *ngIf="isWorkout" #workoutOverlay (onStopWorkout)="onClose()" [restTime]="CircuitRest"
    [currentExercise]="currentExercise"></app-fitness-workout-overlay>
</div>
